import { useNavigate } from 'react-router-dom';
import '../styles/validacaoConvidados.css'

export default function ConfirmaCaptura() {
  const navigate = useNavigate();

    const irParaConfirmaCaptura = () => {
        navigate('/captura-documento');
    };

    return <div className="valida_documento">
        
        <img src='/images/confirma.jpg' alt='validação do documento' className="img_validacao" onClick={irParaConfirmaCaptura} />    
    
    </div>
}